export default "__VITE_ASSET__BOy$IyCN__";